var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useDispatch } from "react-redux";
import { addMultiSelectTicketsToBasket, clearMultiTicketSelections } from "../store/seatmap";
import { useTranslation } from 'react-i18next';
var SeatPopupMulti = function (_a) {
    var selections = _a.selections, concession = _a.concession, error = _a.error;
    var dispatch = useDispatch();
    var _b = useTranslation(), t = _b.t, i18n = _b.i18n;
    var onClose = function () { dispatch(clearMultiTicketSelections()); };
    var onSubmit = function () { dispatch(addMultiSelectTicketsToBasket()); };
    return (_jsx("div", __assign({ style: {
            position: "absolute",
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center"
        } }, { children: _jsxs("div", __assign({ className: 'popover-body', style: {
                bottom: 0,
                position: 'sticky',
                zIndex: 1000,
                display: 'block',
                alignSelf: "flex-end"
            } }, { children: [_jsx("p", __assign({ style: { fontSize: '14px' } }, { children: t("Choose seats for selected ticket type and click Add") })), _jsx("div", __assign({ className: "popover-seat" }, { children: _jsxs("ul", { children: [_jsxs("li", { children: [t('Ticket Type'), _jsx("span", { children: concession.title })] }), _jsxs("li", { children: [t('Price Each'), _jsxs("span", { children: [concession.price, concession.feesTitle && (_jsxs("p", __assign({ className: "display-flex" }, { children: [concession.inclusiveFees ? _jsxs("p", __assign({ className: "multi-fees-label" }, { children: [" ", t('inc'), " "] })) : _jsx("p", __assign({ className: "multi-fees-label" }, { children: "+" })), concession.feesValue, " ", t('fee'), " "] })))] })] }), concession.minimumQty > 1 && (_jsxs("li", { children: [t('Minimum Quantity'), _jsxs("span", { children: [selections.length, "/", concession.minimumQty] })] }))] }) })), _jsxs("div", { children: [_jsx("button", __assign({ disabled: concession.minimumQty > selections.length, onClick: onSubmit }, { children: t('Add') })), " ", _jsx("button", __assign({ onClick: onClose }, { children: t('Cancel') }))] }), _jsx("p", { children: error && error })] })) })));
};
export default SeatPopupMulti;
